import { render } from "./Access.vue?vue&type=template&id=b659d87e"
import script from "./Access.vue?vue&type=script&lang=js"
export * from "./Access.vue?vue&type=script&lang=js"

import exportComponent from "/builds/aplicaciones_mides/tu-mides/frontend-tumides/tuMIDES/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__